import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manifesting_ds_manifesting_shipping_containers_list_tests_onlyService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: {  }): 
  Promise<{ result: { Id?: number, CarrierId?: number, ContainerTypeId?: number, LookupCode?: string, ShipmentId?: number, TrackingNumber?: string, Shipment?: { CarrierId?: number, CarrierServiceTypeId?: number, Incoterms?: string, LookupCode?: string, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string, OwnerId?: number, Owner?: { Id?: number, OwnersCarriersLookups?: { OwnerId?: number, CarrierId?: number, AccountNumber?: string, Instructions?: string, ReferenceNumber?: string }[] } } } }[] } }[] }> 
  {
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_manifesting_shipping_containers_list_tests_only/get`;
    
    const options = {
    }
    
    const body = null;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CarrierId?: number, ContainerTypeId?: number, LookupCode?: string, ShipmentId?: number, TrackingNumber?: string, Shipment?: { CarrierId?: number, CarrierServiceTypeId?: number, Incoterms?: string, LookupCode?: string, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string, OwnerId?: number, Owner?: { Id?: number, OwnersCarriersLookups?: { OwnerId?: number, CarrierId?: number, AccountNumber?: string, Instructions?: string, ReferenceNumber?: string }[] } } } }[] } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_manifesting_shipping_containers_list_tests_only/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, CarrierId?: number, ContainerTypeId?: number, LookupCode?: string, ShipmentId?: number, TrackingNumber?: string, Shipment?: { CarrierId?: number, CarrierServiceTypeId?: number, Incoterms?: string, LookupCode?: string, OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string, OwnerId?: number, Owner?: { Id?: number, OwnersCarriersLookups?: { OwnerId?: number, CarrierId?: number, AccountNumber?: string, Instructions?: string, ReferenceNumber?: string }[] } } } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_manifesting_shipping_containers_list_tests_only/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      }) {
      return false;
    }
}
